/* eslint-disable */
import PropTypes from 'prop-types';
import ThemeStatePropTypes from '../../State/Store/Theme/Theme.props';

const TermsAndConditionsLinkPropTypes = {
  /**
   * The JSS classes to use
   */
  classes: ThemeStatePropTypes.classes.isRequired,

  /**
   * The full screen flag
   */
  fullScreen: PropTypes.bool.isRequired,

  /**
   * The JSS theme to use
   */
  theme: ThemeStatePropTypes.theme,
};

export default TermsAndConditionsLinkPropTypes;
